import { render, staticRenderFns } from "./drugstore.vue?vue&type=template&id=5f7e1206&scoped=true&"
import script from "./drugstore.vue?vue&type=script&lang=js&"
export * from "./drugstore.vue?vue&type=script&lang=js&"
import style0 from "./drugstore.vue?vue&type=style&index=0&id=5f7e1206&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7e1206",
  null
  
)

export default component.exports